import { OfficeServerDetails, UpdateOfficeServerRequest } from "../../../domain/repositories/ConfigRepository";

import {
  TRIGGER_UPDATE_OFFICE_SERVER,
  TriggerUpdateOfficeServer,

  UPDATE_OFFICE_SERVER_PENDING,
  UpdateOfficeServerPending,

  UPDATE_OFFICE_SERVER_SUCCESS,
  UpdateOfficeServerSuccess,

  UPDATE_OFFICE_SERVER_ERROR,
  UpdateOfficeServerError,

  RESET_UPDATE_OFFICE_SERVER,
  ResetUpdateOfficeServer
} from "./types";

export const triggerUpdateOfficeServer = (request: UpdateOfficeServerRequest): TriggerUpdateOfficeServer => {
  return {
    type: TRIGGER_UPDATE_OFFICE_SERVER,
    payload: { request }
  };
};

export const updateOfficeServerPending = (): UpdateOfficeServerPending => {
  return {
    type: UPDATE_OFFICE_SERVER_PENDING
  };
};

export const updateOfficeServerSuccess = (): UpdateOfficeServerSuccess => {
  return {
    type: UPDATE_OFFICE_SERVER_SUCCESS,

  };
};

export const updateOfficeServerError = (): UpdateOfficeServerError => {
  return {
    type: UPDATE_OFFICE_SERVER_ERROR,
  };
};

export const resetUpdateOfficeServer = (): ResetUpdateOfficeServer => {
  return {
    type: RESET_UPDATE_OFFICE_SERVER,
  };
};